module.exports = __webpack_public_path__ + "static/media/wallet2.b5dc484d.svg";